import { render, staticRenderFns } from "./CorralesMain.vue?vue&type=template&id=2e58dcda"
import script from "./CorralesMain.vue?vue&type=script&lang=js"
export * from "./CorralesMain.vue?vue&type=script&lang=js"
import style0 from "./CorralesMain.vue?vue&type=style&index=0&id=2e58dcda&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports